import React from 'react'
import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const containerColumns = {
  xl: 4,
  md: 3,
  sm: 2,
  xs: 1
}

export const elementColumns = {
  oneColumn: {
    xs: 1
  },
  halfColumn: {
    xs: 0.5
  }
}

export const columnSpacing = {
  xl: 3,
  md: 3,
  sm: 2,
  xs: 2
}

/**
 * This is to form the grid with 4 children in xl screen, 3 in lg, 2 in md, 1 in xs with respect to the parent div size NOT with viewport size ( i.e with respective to container name responsive-container which is below.
 *
 *  How to use it: Wrap this component for which responsive is required with respective to it's size and pass the className 'responsive-grid' to the child component
 * @example Example :
 * <CustomResponsiveGrid> <Grid className='responsive-grid' > </Grid> <CustomResponsiveGrid/>
 */
export const CustomResponsiveGrid = ({ children }: any): JSX.Element => {
  const StyledBox = styled(Box)(({ theme }) => ({
    containerType: 'inline-size',
    containerName: 'responsive-container',
    [`@container responsive-container (min-width: ${theme.breakpoints.values.xs}px)`]: {
      '.responsive-grid': { display: 'grid', gap: theme.spacing(0), gridTemplateColumns: '1fr' },
      '.responsive-grid > div': { maxWidth: 'unset' }
    },
    [`@container responsive-container (min-width: ${theme.breakpoints.values.sm}px)`]: {
      '.responsive-grid': { display: 'grid', gap: theme.spacing(0), gridTemplateColumns: '1fr 1fr' },
      '.responsive-grid > div': { maxWidth: 'unset' }
    },
    [`@container responsive-container (min-width: ${theme.breakpoints.values.sm + ((theme.breakpoints.values.md - theme.breakpoints.values.sm) / 2)}px)`]: {
      '.responsive-grid': { display: 'grid', gap: theme.spacing(0), gridTemplateColumns: '1fr 1fr 1fr' },
      '.responsive-grid > div': { maxWidth: 'unset' }
    },
    [`@container responsive-container (min-width: ${theme.breakpoints.values.md}px)`]: {
      '.responsive-grid': { gridTemplateColumns: '1fr 1fr 1fr' },
      '.responsive-grid > div': { maxWidth: 'unset' }
    },
    [`@container responsive-container (min-width: ${theme.breakpoints.values.lg}px)`]: {
      '.responsive-grid': { gridTemplateColumns: '1fr 1fr 1fr' },
      '.responsive-grid > div': { maxWidth: 'unset' }
    },
    [`@container responsive-container (min-width: ${theme.breakpoints.values.xl}px)`]: {
      '.responsive-grid': { gridTemplateColumns: '1fr 1fr 1fr 1fr' },
      '.responsive-grid > div': { maxWidth: 'unset' }
    }
  }))

  return (<><StyledBox>{children}</StyledBox></>)
}
